/**
 * This file was automatically generated by `IconCodeGenerator`.
 * DO NOT MODIFY IT BY HAND. Instead, follow the instructions at `src/shared/joykit/packages/core/icons/README.md`.
 */

import * as React from 'react';

import createSvgIcon from '../createSvgIcon';

import { SvgIconConfig } from '../types';

const config: SvgIconConfig = {
  title: 'Help',
  definitions: {
    '24': {
      viewBox: '0 0 24 24',
      path: (
        <>
          <path
            d="M12 7.25a2.4 2.4 0 0 0-2.4 2.4.6.6 0 0 1-1.2 0 3.6 3.6 0 0 1 7.2 0c0 1.36-.902 2.22-1.603 2.888l-.083.08c-.772.74-1.315 1.308-1.315 2.206a.6.6 0 0 1-1.2 0c0-1.46.94-2.36 1.664-3.053l.02-.02c.8-.756 1.315-1.282 1.315-2.1a2.4 2.4 0 0 0-2.4-2.4zm0 10.663c.345 0 .625-.28.625-.625s-.28-.625-.625-.625-.625.28-.625.625.28.625.625.625z"
            fill="currentColor"
          />{' '}
          <path
            fillRule="evenodd"
            d="M1 12C1 5.933 5.933 1 12 1s11 4.933 11 11-4.933 11-11 11S1 18.067 1 12zm11-9.8c-5.404 0-9.8 4.396-9.8 9.8s4.396 9.8 9.8 9.8 9.8-4.396 9.8-9.8-4.396-9.8-9.8-9.8z"
            fill="currentColor"
          />
        </>
      )
    }
  }
};

const icon = createSvgIcon(config);
export default icon;
